/** ISO-Datum als deutsches Datum. Bewusst ohne Intl — der Stand ist ein
 *  fester String aus den Daten, keine Zeitzonen-Frage. */
export function formatDate(iso: string): string {
  const [y, m, d] = iso.split('-');
  return `${d}.${m}.${y}`;
}
